<div class="efile-xml-compare" [class.efile-xml-compare--results-only]="resultsOnly()">
  @if (!resultsOnly()) {
  <header class="efile-xml-compare__header">
    <h2 class="efile-xml-compare__title">IRS XML Comparison</h2>
    <p class="efile-xml-compare__subtitle">
      Select two IRS-submitted XML files for this return and compare element-level differences.
    </p>
  </header>
  }

  @if (resultsOnly()) {
  <h3 class="efile-xml-compare__section-title">IRS XML comparison</h3>
  }

  @if (!resultsOnly()) {
  <section
    class="efile-xml-compare__toolbar gt-filter-container"
    aria-label="XML selection"
  >
    <div class="filter-col filter-refresh">
      @if (optionsLoading) {
      <i class="fa fa-spinner fa-spin gt-refresh" aria-hidden="true"></i>
      } @else {
      <i
        class="fa fa-refresh gt-refresh"
        role="button"
        tabindex="0"
        title="Reload IRS submissions"
        aria-label="Reload IRS submissions"
        (click)="reloadOptions()"
        (keyup.enter)="reloadOptions()"
      ></i>
      }
    </div>

    @if (leftFilter && !leftFilter.loading) {
    <div class="filter-col filter-dropdown">
      <div
        df-select-single
        [attr.aria-label]="leftFilter.label"
        [filter]="leftFilter"
        (filterChange)="onLeftFilterChange($event)"
      ></div>
    </div>
    }

    @if (rightFilter && !rightFilter.loading) {
    <div class="filter-col filter-dropdown">
      <div
        df-select-single
        [attr.aria-label]="rightFilter.label"
        [filter]="rightFilter"
        (filterChange)="onRightFilterChange($event)"
      ></div>
    </div>
    }

    <div class="filter-col filter-action">
      <button
        type="button"
        class="efile-xml-compare__compare-btn"
        [disabled]="comparing || optionsLoading"
        (click)="compare()"
      >
        <i class="fa" [class.fa-spinner]="comparing" [class.fa-spin]="comparing" [class.fa-exchange]="!comparing" aria-hidden="true"></i>
        Compare
      </button>
    </div>
  </section>
  }

  @if (validationMessage) {
  <div class="efile-xml-compare__alert efile-xml-compare__alert--warn" role="alert">
    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
    {{ validationMessage }}
  </div>
  }

  <section class="efile-xml-compare__results" aria-live="polite">
    @switch (compareState.kind) {
      @case ('loading') {
      <div class="efile-xml-compare__state">
        <i class="fa fa-spinner fa-pulse" aria-hidden="true"></i>
        Loading IRS XML comparison…
      </div>
      }
      @case ('empty') {
      <div class="efile-xml-compare__alert efile-xml-compare__alert--info" role="status">
        <i class="fa fa-check-circle" aria-hidden="true"></i>
        No differences were found. The selected files are identical, or the same IRS submission was selected in both dropdowns.
      </div>
      }
      @case ('error') {
      <div class="efile-xml-compare__alert efile-xml-compare__alert--error" role="alert">
        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
        {{ compareErrorMessage }}
      </div>
      }
    }

    @if (showGrid) {
    <div class="efile-xml-compare__grid-host">
      <div
        efileGrid
        #xmlCompareGrid="efileGrid"
        class="gizmo-grid efile-xml-compare__grid"
        [gridConfig]="gridConfig"
        (gridDataLoaded)="onGridDataLoaded($event)"
        (excelExportRequested)="onExcelExport($event)"
      ></div>
    </div>
    }
  </section>
</div>

